import { Injectable, signal, WritableSignal } from '@angular/core';
import { environment } from '@environment';
import { HttpApi } from './http.api';
import { map, Observable } from 'rxjs';
import { Folder, FolderQueryParams } from '@core/models/folder.model';
import { PaginatedData } from '@core/models/pagination.models';

@Injectable({
  providedIn: 'root',
})
export class FolderService {
  private readonly baseUrl: string = environment.apiUrl;

  access: WritableSignal<boolean> = signal(false);

  folder: WritableSignal<Folder | null> = signal(null);

  constructor(private httpApi: HttpApi) {}

  getFolders(params: FolderQueryParams): Observable<PaginatedData<Folder>> {
    return this.httpApi.get<PaginatedData<Folder>>(`${this.baseUrl}/folder`, { params });
  }

  getFolderById(id: string): Observable<Folder> {
    this.access.set(false);
    return this.httpApi.get<Folder>(`${this.baseUrl}/folder/${id}`).pipe(
      map(res => {
        this.access.set(res.access ?? false);
        this.folder.set(res);
        return res;
      })
    );
  }
}
